module.exports = __webpack_public_path__ + "static/accreditations3-02fbd17229a246e9c5a709cd5f58c209.png";